/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React, { useEffect, useState, useContext } from "react";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import useMediaQuery from "@mui/material/useMediaQuery";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { v4 } from "uuid";
import { getMenuDetails } from "./requestCall";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import smallBenzIcon from "../../assets/icons/favicon.svg";
import { os } from "../../utils/util";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import MyContext from "../context/MyContext";

const footerWrapper = css`
  .MuiTypography-root {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif !important;
  }
  background: #000;
  width: 100%;
  .MuiTypography-root {
    font-size: 11px;
    color: #7b7b7b;
  }
  a {
    text-decoration: none;
  }
  a:hover {
    color: #06a4ed;
  }
`;
const footerContent = (matches) => css`
  display: flex;
  margin: 0 ${matches ? "10px" : "46px"};
  flex-wrap: wrap;
  justify-content: ${matches ? "flex-start" : "center"};
`;
const footerNav = (matches, matchesPad, isPc) => css`
  margin-top: 20px;
  display: ${!isPc ? "none" : "flex"};
  width: ${matchesPad ? "100%" : "60%"};
  .MuiTypography-root {
    height: 21px;
  }
`;
const footerNavItem = css`
  display: flex;
  flex-direction: column;
`;
const navBlock = css`
  flex: 1;
`;
const firstNav = css`
  color: white;
  font-weight: bold;
`;
const secNav = css`
  color: #7b7b7b;
`;
const officialApp = (matches, matchesPad) => css`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  width: ${matchesPad && !matches ? "100%" : matches ? "100%" : "40%"};
  color: #7b7b7b;
  div {
    display: flex;
    .MuiTypography-root {
      line-height: 20px;
    }
  }
  .MuiTooltip-popper {
    .MuiTooltip-tooltip {
      background: rgba(0, 0, 0, 0);
      margin-bottom: 0;
      img {
        width: 200px;
      }
    }
  }
`;
const footer = (matches) => css`
  padding-top: ${matches ? "15px" : "0"};
  border-top: ${matches ? "1px solid" : "none"};
  margin: ${matches ? "15px 10px 0 10px" : "30px 46px 0 46px"};
  padding-bottom: ${matches ? "15px" : "10px"};
  color: #7b7b7b;
  .MuiTypography-caption {
    margin: 0 10px;
  }
  div {
    .MuiTypography-root {
      line-height: 25px;
    }
  }
`;
const moveToTop = (matches) => css`
  z-index: 5;
  cursor: pointer;
  position: fixed;
  right: ${matches ? "16px" : "46px"};
  bottom: ${matches ? "163px" : "6px"};
  color: #969696;
  svg {
    margin: 0 auto;
    display: block;
    color: white;
  }
  p {
    position: relative;
    top: -5px;
  }
`;
const recordNumber = (matches) => css`
  display: flex;
  flex-direction: ${matches ? "column" : "row"};
  .MuiTypography-root {
    margin-right: 20px;
  }
`;
const officialAppListWrapper = css`
  height: 20px;
  cursor: pointer;
  display: flex;
  img {
    margin-right: 5px;
    height: 20px;
  }
`;
const tradeMark = css`
  display: flex;
  img {
    width: 13px;
    vertical-align: sub;
    margin-right: 5px;
  }
`;
const additionalLink = css`
  display: flex;
  div {
    display: flex;
  }
  .MuiTypography-caption {
  }
  a {
    color: #7b7b7b;
    text-decoration: none;
  }
  a:hover {
    color: #06a4ed;
  }
`;
const itemContainer = css`
  display: flex;
  align-items: top;
`;
const itemImage = css`
  margin-top: 5px;
  width: 15px;
  height: 15px;
`;
const sortByOrder = (data) => {
  return data?.sort((a, b) => a.order - b.order);
};
const getProducts = (products, dataAttribute, setTabValue) => {
  return (
    <>
      {sortByOrder(products).map((product) => (
        <div key={product.id}>
          {sortByOrder(product.children).map((childItem) => (
            <Typography key={childItem.id}>
              <LinkComp
                css={secNav}
                to={childItem?.target === "_blank" ? "#" : childItem?.url}
                onClick={() =>
                  handleLinkClick(
                    childItem.target,
                    childItem.url,
                    dataAttribute,
                    setTabValue
                  )
                }
              >
                {childItem.title}
              </LinkComp>
            </Typography>
          ))}
        </div>
      ))}
    </>
  );
};
const backToTop = () => {
  (function smoothscroll() {
    var currentScroll =
      document.documentElement.scrollTop || document.body.scrollTop;
    if (currentScroll > 0) {
      window.requestAnimationFrame(smoothscroll);
      window.scrollTo(0, currentScroll - currentScroll / 5);
    }
  })();
};
const LinkComp = styled(Link)(() => ({}));
const handleLinkClick = (target, url, dataAttribute, setTabValue) => {
  if (target === "_blank") window.open(url, "_blank");
  if (dataAttribute) setTabValue(dataAttribute);
};
const Footer = () => {
  const { setTabValue } = useContext(MyContext);
  const [footerNavigation, setFooterNavigation] = useState([]);
  const [officialApps, setOfficialApps] = useState([]);
  const [copyrightPolicy, setCopyrightPolicy] = useState([]);
  const [companyCopyright, setCompanyCopyright] = React.useState("");
  const [companyTrademark, setCompanyTrademark] = React.useState("");
  const [open, setOpen] = React.useState("");
  const [record, setRecord] = React.useState("");
  const matches = useMediaQuery("(max-width: 415px)");
  const matchesPad = useMediaQuery("(max-width: 720px)");
  const handleTooltipClose = () => {
    setOpen("");
  };
  const handleOfficialAppClick = (e, id) => {
    e.stopPropagation();
    setOpen(id);
  };

  useEffect(() => {
    getMenuDetails().then((response) => {
      const footerData = response?.data?.menus;
      footerData?.forEach((item) => {
        item.id === 6 && setCopyrightPolicy(item);
        item.id === 2 && setFooterNavigation(item);
        item.id === 5 && setOfficialApps(item);
        item.id === 7 && setCompanyCopyright(item.items[0]);
        item.id === 8 && setCompanyTrademark(item.items[0]);
        item.id === 9 && setRecord(item);
      });
    });
  }, []);

  return (
    <div css={footerWrapper}>
      <div css={() => footerContent(matches)}>
        <div css={() => footerNav(matches, matchesPad, os().isPc)}>
          {sortByOrder(footerNavigation?.items)?.map((item) => (
            <div css={navBlock} key={item.id}>
              <Typography css={firstNav}>{item.title}</Typography>
              <div css={footerNavItem}>
                {item.id === 20
                  ? getProducts(item.children, item.dataAttribute, setTabValue)
                  : sortByOrder(item?.children).map((childItem, index) => (
                      <Typography key={childItem.id}>
                        <LinkComp
                          css={secNav}
                          to={
                            childItem?.target === "_blank"
                              ? "#"
                              : childItem?.url
                          }
                          state={{ id: index }}
                          onClick={() =>
                            handleLinkClick(
                              childItem.target,
                              childItem.url,
                              item.dataAttribute,
                              setTabValue
                            )
                          }
                        >
                          {childItem.title}
                        </LinkComp>
                      </Typography>
                    ))}
              </div>
            </div>
          ))}
        </div>
        <div css={() => officialApp(matches, matchesPad)}>
          {officialApps?.items?.map((item) => {
            return (
              <Grid item key={item.id}>
                {!os().isPc ? (
                  <ClickAwayListener onClickAway={handleTooltipClose}>
                    <div>
                      {item.url ? (
                        <a href={item.url} target={item.target}>
                          <div css={officialAppListWrapper}>
                            <img
                              src={`${process.env.REACT_APP_BASEURL}${item?.icon?.url}`}
                              alt={item.title}
                            />
                            <Typography>{item.title}</Typography>
                          </div>
                        </a>
                      ) : (
                        <Tooltip
                          PopperProps={{
                            disablePortal: true,
                          }}
                          open={open === item.id}
                          disableFocusListener
                          disableHoverListener
                          disableTouchListener
                          placement="top"
                          title={
                            <div>
                              <img
                                src={`${process.env.REACT_APP_BASEURL}${item?.thumbnailImage?.url}`}
                                alt={item.title}
                              />
                            </div>
                          }
                        >
                          <div
                            css={officialAppListWrapper}
                            onClick={(e) => handleOfficialAppClick(e, item.id)}
                          >
                            <img
                              src={`${process.env.REACT_APP_BASEURL}${item.icon?.url}`}
                              alt={item.title}
                            />
                            <Typography>{item.title}</Typography>
                          </div>
                        </Tooltip>
                      )}
                    </div>
                  </ClickAwayListener>
                ) : (
                  <div>
                    {item?.url ? (
                      <LinkComp
                        to={item?.target === "_blank" ? "#" : item?.url}
                        onClick={() => handleLinkClick(item.target, item.url)}
                      >
                        <div css={officialAppListWrapper}>
                          <img
                            src={`${process.env.REACT_APP_BASEURL}${item?.icon?.url}`}
                            alt={item.title}
                          />
                          <Typography>{item.title}</Typography>
                        </div>
                      </LinkComp>
                    ) : (
                      <Tooltip
                        PopperProps={{
                          disablePortal: true,
                        }}
                        placement="top"
                        title={
                          <div>
                            <img
                              src={`${process.env.REACT_APP_BASEURL}${item?.thumbnailImage?.url}`}
                              alt={item.title}
                            />
                          </div>
                        }
                      >
                        <div css={officialAppListWrapper}>
                          <img
                            src={`${process.env.REACT_APP_BASEURL}${item?.icon?.url}`}
                            alt={item.title}
                          />
                          <Typography>{item.title}</Typography>
                        </div>
                      </Tooltip>
                    )}
                  </div>
                )}
              </Grid>
            );
          })}
        </div>
      </div>
      <div css={() => footer(matches)}>
        <div css={tradeMark}>
          <img src={smallBenzIcon} alt="small benz icon" />
          <Typography>{companyTrademark?.title}</Typography>
        </div>
        <div css={additionalLink}>
          {copyrightPolicy?.items?.map((item, index) => (
            <div key={v4()}>
              <Typography>
                <LinkComp
                  to={item?.target === "_blank" ? "#" : item?.url}
                  onClick={() => handleLinkClick(item.target, item.url)}
                >
                  {item.title}
                </LinkComp>
              </Typography>
              {index < copyrightPolicy?.items.length - 1 && (
                <Typography variant="caption">|</Typography>
              )}
            </div>
          ))}
        </div>
        <div css={() => recordNumber(matchesPad)}>
          <Typography>{companyCopyright?.title}</Typography>
          {record?.items?.map((item, index) => (
            <div key={item.id} css={itemContainer}>
              {index === 0 && (
                <img
                  src={`${process.env.REACT_APP_BASEURL}${item?.thumbnailImage?.url}`}
                  alt="item.title"
                  css={itemImage}
                />
              )}
              <Typography key={item.id}>{item.title}</Typography>
            </div>
          ))}
        </div>
      </div>
      <div css={() => moveToTop(matches)} onClick={backToTop}>
        <KeyboardArrowUpIcon />
        <Typography>返回顶部</Typography>
      </div>
    </div>
  );
};

export default Footer;
